import GridEngine from "grid-engine";
import { AUTO, Game, Types } from "phaser";
import GesturesPlugin from "phaser3-rex-plugins/plugins/gestures-plugin.js";
import OutlinePipelinePlugin from "phaser3-rex-plugins/plugins/outlinepipeline-plugin.js";
// Find out more information about the Game Config at:
// https://docs.phaser.io/api-documentation/typedef/types-core#gameconfig
const config: Types.Core.GameConfig = {
  type: AUTO,
  width: 384,
  height: 384,
  parent: "game-container",
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  pixelArt: true,
  physics: {
    default: "arcade",
  },
  audio: {
    disableWebAudio: false,
  },
  plugins: {
    global: [
      {
        key: "rexOutlinePipeline",
        plugin: OutlinePipelinePlugin,
        start: true,
      },
    ],
    scene: [
      {
        key: "gridEngine",
        plugin: GridEngine,
        mapping: "gridEngine",
      },
      {
        key: "rexGestures",
        plugin: GesturesPlugin,
        mapping: "rexGestures",
      },
    ],
  },
};

const StartGame = (parent: string) => {
  const gameConfig = {
    ...config,
    parent,
  };
  return new Game(gameConfig);
};

export default StartGame;
